import { render, staticRenderFns } from "./mba.vue?vue&type=template&id=2138aa05"
import script from "./mba.vue?vue&type=script&lang=ts"
export * from "./mba.vue?vue&type=script&lang=ts"
import style0 from "./mba.vue?vue&type=style&index=0&id=2138aa05&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports